import { createAction } from '@ngrx/store';

export const enterLoginPageAction = createAction('[Current User] Enter Login Page');
export const requestLoginAction = createAction('[Current User] Request Login');
export const confirmLogoutAction = createAction('[Current User] Confirm Logout');
export const cancelLogoutAction = createAction('[Current User] Cancel Logout');
